import { render, staticRenderFns } from "./AppSwiperSlide.vue?vue&type=template&id=384e437c"
import script from "./AppSwiperSlide.vue?vue&type=script&lang=js"
export * from "./AppSwiperSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports